<template>
  <div :style="iconStyle" class="rt-icon" @click="click">
    <template v-if="!!iconName">
      <svg v-if="type === 'svg'" :width="size" :height="size" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
        aria-hidden="true">
        <use :xlink:href="'#' + iconName" :fill="computedColor" />
      </svg>
      <i v-else-if="type === 'iconFont'" :class="'rt-icon-font ' + iconName" :style="{ 'font-size': size + 'px' }"></i>
    </template>
    <img v-else-if="!!iconSrc" :width="size" :height="size" :src="iconSrc" @error="errorHandler" />
  </div>
</template>

<script>
import config from '../../config';
export default {
  name: 'RtIcon',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    name: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: 16
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String
    },
    type: {
      type: String,
      default: 'svg'
    }
  },
  data() {
    return {
      iconName: this.name,
      iconSrc: this.imgSrc
    };
  },
  computed: {
    iconStyle() {
      const strSize = this.size + '';
      const pixel = strSize.indexOf('px') === -1 ? strSize + 'px' : strSize;
      let style = { height: pixel, width: pixel };
      if (this.color && this.color.toLowerCase() !== 'currentcolor' && this.type === 'iconFont') {
        style.color = this.computedColor;
      }
      return style;
    },
    computedColor() {
      return (
        this.SCSS_VARIABLES[`COLOR_${this.color.toUpperCase()}`] || this.color
      );
    }
  },
  watch: {
    imgSrc() {
      this.iconSrc = this.imgSrc;
      this.iconName = '';
    },
    name() {
      this.iconName = this.name;
    }
  },
  methods: {
    click(event) {
      if (!this.disabled) this.$emit('click', event);
    },
    errorHandler(e) {
      this.iconSrc = '';
      this.iconName = config.get().defaultIconName;
      console.log('image load error');
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtIcon.vue?08843caf